import React, { createContext, useContext, useEffect, useState } from "react";
import axiosInstance from "services/httpInterceptor";
import { useAuth } from "./AuthContext";

const PressContext = createContext();

export const usePress = () => useContext(PressContext);

export const PressProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [selectedPress, setSelectedPress] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pressOptions, setPressOptions] = useState([]);

  useEffect(() => {
    const fetchPressSources = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get(`/v1/news/presses/sources`);
        const allOptions = [
          { id: null, name: "All Sources" },
          ...response.data
        ];

        setPressOptions(allOptions);
      } catch (error) {
        console.error('Error fetching press sources:', error);
        setPressOptions([]);
      } finally {
        setLoading(false);
      }
    };

    if (isAuthenticated) {
      fetchPressSources();
    } else {
      setPressOptions([]);
      setLoading(false);
    }
  }, [isAuthenticated]);

  return (
    <PressContext.Provider value={{ selectedPress, setSelectedPress, pressOptions, loading }}>
      {children}
    </PressContext.Provider>
  );
};